import React from 'react';
import PropTypes from 'prop-types';
import { getFinancialsSectionData } from './configStructure.js';
import { format } from 'date-fns';
import './FinancialsSection.scss';

const handlePrecision = (amount, precision) => {
    if (amount !== undefined && amount !== null) {
        // Keeping below commented code for future reference
        // const arr = `${amount}`.split('.');
        // return arr.length > 1
        //     ? `${arr[0] <= 0 ? arr[0] * -1 : arr[0]}.${arr[1].length === 1 ? `${arr[1]}0` : arr[1].substr(0, precision)}`
        //     : `${amount <= 0 ? amount * -1 : amount}.00`;
        return (Math.round(amount * 100) / 100).toFixed(2);
    }
    return '--';
};
const FinancialsSection = (props) => {
    const financialData = getFinancialsSectionData();

    function getFieldDataList(structureList) {
        let value, currencyCode;
        return <table>
            <tbody>
                {props.fields.Ledgers !== undefined && Array.isArray(props.fields.Ledgers) === true && props.fields.Ledgers.map((fieldValue, index) => {
                    if (fieldValue[structureList.columnKey] === null || fieldValue[structureList.columnKey] === undefined) {
                        value = "--";
                    }
                    else {
                        switch (structureList.displayType) {
                            case "DATE":
                                value = format(fieldValue[structureList.columnKey], 'MMM dd, yyyy ');
                                break;
                            case "CURRENCY":
                                value = handlePrecision(fieldValue[structureList.columnKey], 2);
                                currencyCode = fieldValue["currencyCode"];
                                return <tr key={index}>
                                    <td className="align-amount-value">{value === undefined ? "--" : value}{' '}{currencyCode}</td>
                                </tr>
                            case "ADJUSTMENTS":
                                value = `${fieldValue["adjustments"]} = GL ${fieldValue[structureList.columnKey]} (${fieldValue["description"]})`;
                                break;
                            default:
                                value = fieldValue[structureList.columnKey];
                                break;

                        }
                    }
                    return <tr key={index}>
                        <td>{value === undefined ? "--" : value}</td>
                    </tr>
                })}
            </tbody>
        </table>
    }
    return <div className="financials-section-card" >

        <span className="section-title">{props.sectionName}<span className="scope-divider"></span><span className="scope-view">{props.sectionScope}</span></span>
        <span className="section-view" key={financialData.dataColumns?.columnKey}>
            {props.fields.Ledgers !== undefined && financialData.dataColumns?.map((list, index) => {


                return <span className="list-view" key={index}>
                    <span className="list-title">{list.name}</span>
                    <span className="list-value">{getFieldDataList(list)}</span>
                </span>


            })}
            {props.fields.Ledgers !== undefined && <span className="divider">{" "}</span>}
            {financialData.settlementColumns.map((list, index) => {
                return <span className="settlement-list-view" key={index}>
                    <span className="settlement-list-title">{list.name}</span>
                    {props.fields[list.columnKey] === undefined ? <span className="settlement-list-value">{"--"}</span> : <span className="settlement-list-value">{props.fields[list.columnKey]}</span>}
                </span>

            })}

        </span>

    </div>


};

FinancialsSection.propTypes = {
    Ledgers: PropTypes.array,
    settlementDetails: PropTypes.object,
    sectionName: PropTypes.string,
    sectionScope: PropTypes.string

};

FinancialsSection.defaultProps = {
};

export default (FinancialsSection);
